// removed by extract-text-webpack-plugin
module.exports = {"heading":"heading__1m3m4","sideBar":"sideBar__2TgWj","map":"map__2qD37","wrapper":"wrapper__1G8KD","sankey":"sankey__DQ_bh","makeImpact":"makeImpact__kfVkb","financial_flow":"financial_flow__2YyF_","mainDescription":"mainDescription__1wA2V"};


//////////////////
// WEBPACK FOOTER
// ./routes/tmp_home_financial_component/style.css
// module id = pzkh
// module chunks = 9